"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrCustomMapControl = void 0;
const api_1 = require("@react-google-maps/api");
const react_1 = require("react");
const fdr_map_constants_1 = require("./fdr-map.constants");
function FdrCustomMapControl({ onCreateControl, position = fdr_map_constants_1.FdrMapControlPosition.TOP_RIGHT, }) {
    const map = (0, api_1.useGoogleMap)();
    (0, react_1.useEffect)(() => {
        if (!map)
            return;
        const controlPosition = google.maps.ControlPosition[position];
        const { element: mapControl, cleanup } = onCreateControl();
        let place = map.controls[controlPosition];
        place.push(mapControl);
        return () => {
            // remove control from map
            place = map.controls[controlPosition];
            if (!place)
                return;
            place.removeAt(place.getArray().indexOf(mapControl));
            // explicitly clean up event listeners
            cleanup === null || cleanup === void 0 ? void 0 : cleanup();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map]);
    return null;
}
exports.FdrCustomMapControl = FdrCustomMapControl;
//# sourceMappingURL=fdr-custom-map-control.js.map